import { ApoyoLista } from "../shared/model/iso42001/matriz-riesgo.model";

/**
 * Los datos del FORMATO FOS-005: su título, la organización, su versión y su
 * fecha de liberación.
 *
 * Son los mismos para todas las matrices (es UN formato para todas las
 * áreas) y se editan en Gestión de Hojas de Apoyo (decisión de Norman,
 * 29/09/2026). Viven en iso42001_apoyo_lista, un renglón por dato (listas
 * FMT_*); mientras no se captura un dato vale el de siempre.
 *
 * El Excel usa la misma regla en el servidor (FormatoFos005.java): si algo
 * cambia aquí, cambia allá.
 *
 * No confundir con la versión del DOCUMENTO de cada matriz, que es la de su
 * historial de cambios.
 */
export const LISTAS_FORMATO = {
  titulo: "FMT_TITULO",
  organizacion: "FMT_ORGANIZACION",
  version: "FMT_VERSION",
  liberacion: "FMT_LIBERACION",
} as const;

export type DatoFormato = keyof typeof LISTAS_FORMATO;

export interface DatosFormato {
  titulo: string;
  organizacion: string;
  version: string;
  /** En ISO (2026-05-03); fechaFormato() la ensenia dd/MM/yyyy. */
  liberacion: string;
}

export const FORMATO_DE_SIEMPRE: DatosFormato = {
  titulo: "FOS-005 Plan de Respuesta al Riesgo",
  organizacion: "Centro Operativo Solser",
  version: "1.17",
  liberacion: "2026-05-03",
};

/** El renglón vigente de un dato: el primero activo con texto. */
export function renglonFormato(listas: ApoyoLista[] | null | undefined, dato: DatoFormato): ApoyoLista | null {
  const lista = LISTAS_FORMATO[dato];
  return (listas || []).find((a) => a.lista === lista && a.estatus !== "INACTIVO" && !!(a.texto || "").trim()) || null;
}

/** Los datos vigentes del formato, con los de siempre donde falte alguno. */
export function datosFormato(listas: ApoyoLista[] | null | undefined): DatosFormato {
  const valor = (dato: DatoFormato) => (renglonFormato(listas, dato)?.texto || "").trim() || FORMATO_DE_SIEMPRE[dato];
  return {
    titulo: valor("titulo"),
    organizacion: valor("organizacion"),
    version: valor("version"),
    liberacion: valor("liberacion"),
  };
}

/** «2026-05-03» → «03/05/2026». Si no es ISO, se deja como viene. */
export function fechaFormato(iso: string): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec((iso || "").trim());
  return m ? `${m[3]}/${m[2]}/${m[1]}` : iso;
}

/** La misma regla que valida el servidor para la versión: 1.17, 2.0.1… */
export const VERSION_FORMATO_VALIDA = /^\d{1,3}(\.\d{1,3}){0,2}$/;
